export default __webpack_public_path__ + "static/media/globe.0ee70faa.svg";